import { headers_custom_func_get, headers_custom_func_get_for_RFQ, headers_file_func_get } from "../Auth/get_set_AuthHeaders";
import {apiUriHttp, apiUriExcelHttp} from "../conf/apiConf";

async function fetchAllDataGet_byApiName(apiName: string, baseUri: string = apiUriHttp()): Promise<any> {
  //console.log(apiName, 'called');
  try {
    const response = await fetch(baseUri + apiName, {
      method: 'GET',
      headers: headers_custom_func_get(),
    });

    if (!response.ok) {
      if (response.status === 401) {
        console.log('UNAUTHORIZED');
      }
      throw new Error('Failed to fetch equipment groups');
    }
    else{
      const data = await response.json();
      return data.responseData;
    }

  } catch (error) {
    console.log(error);
    // Handle the error, such as displaying an error message or setting an error state
    throw error; // Re-throw the error to propagate it to the caller
  }
}

async function fetchAllDataGet_byApiName_for_RFQ(apiName: string, baseUri: string = apiUriHttp()): Promise<{ headers: Headers, data: string }> {
  try {
    const response = await fetch(baseUri + apiName, {
      method: 'GET',
      headers: headers_custom_func_get_for_RFQ(),
    });

    if (!response.ok) {
      if (response.status === 401) {
        console.log('UNAUTHORIZED');
      }
      throw new Error('Failed to fetch data');
    } else {
      const headers = response.headers;
      const blob = await response.blob();
      const reader = new FileReader();

      return new Promise<{ headers: Headers, data: string }>((resolve, reject) => {
        reader.onloadend = () => {
          if (typeof reader.result === 'string') {
            resolve({
              headers: headers,
              data: reader.result
            });
          } else {
            reject(new Error('Failed to read response as base64 string'));
          }
        };
        reader.onerror = () => {
          reject(new Error('Error reading response as base64 string'));
        };
        reader.readAsDataURL(blob);
      });
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
}

async function fetchAllDataGetFromAppFile_byApiName(apiName: string, baseUri: string = apiUriExcelHttp()): Promise<any> {
  //console.log(apiName, 'called');
  try {
    const response = await fetch(baseUri + apiName, {
      method: 'GET',
      headers: headers_file_func_get(),
    });

    if (!response.ok) {
      if (response.status === 401) {
        console.log('UNAUTHORIZED');
      }
      throw new Error('Failed to fetch equipment groups');
    }
    else{
      const data = await response.json();
      //console.log(data);
      return data.responseData;

    }
  } catch (error) {
    console.log(error);
    // Handle the error, such as displaying an error message or setting an error state
    throw error; // Re-throw the error to propagate it to the caller
  }
}

// Downloads a file returned by a GET endpoint (e.g. AppFile/downloadExcelFile) and saves it in the browser under the
// name the API sends in Content-Disposition (else `fallbackFileName`). A JSON reply instead of a file means the API
// refused (e.g. user not found), which is thrown as an error carrying the API's message.
async function downloadFileGet_byApiName(apiName: string, fallbackFileName: string, baseUri: string = apiUriExcelHttp()): Promise<string> {
  const response = await fetch(baseUri + apiName, {
    method: 'GET',
    headers: headers_file_func_get(),
  });

  const contentType = response.headers.get('Content-Type') ?? '';
  if (!response.ok || contentType.includes('application/json')) {
    let message = `Download failed (${response.status})`;
    try {
      const data = await response.json();
      message = data?.responseData ?? data?.message ?? message;
    } catch {
      // not JSON - keep the status message
    }
    throw new Error(message);
  }

  const disposition = response.headers.get('Content-Disposition') ?? '';
  const match = /filename\*=UTF-8''([^;]+)|filename="?([^";]+)"?/i.exec(disposition);
  const fileName = match ? decodeURIComponent(match[1] ?? match[2]) : fallbackFileName;

  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
  return fileName;
}

export {
  fetchAllDataGet_byApiName,
  fetchAllDataGet_byApiName_for_RFQ,
  fetchAllDataGetFromAppFile_byApiName,
  downloadFileGet_byApiName
}
